import React from "react";
import { Link } from "react-router-dom";
import sidebarIcon from "../assets/analysis.svg";
import jsonIcon from "../assets/json.svg";
import homeIcon from "../assets/home.svg";
import { ReportLoadStatus } from "../store";
import "./MainLayout.scss";

// Define the types for the props Sidebar will receive
interface SidebarProps {
  mainTab: number;
  setMainTab: (tabId: number) => void; // This assumes setMainTab is a function taking a number and returning void
  reportLoadStatus: ReportLoadStatus;
}

const Sidebar: React.FC<SidebarProps> = ({
  mainTab,
  setMainTab,
  reportLoadStatus,
}) => {
  const sidebarItems = [
    { id: 1, icon: sidebarIcon, label: "Analysis" },
    { id: 0, icon: jsonIcon, label: "Output" },
  ];

  // Hide home button on mobile
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 650;
  return (
    <div className="sidebar">
      {/* Home button removed on mobile, shown only on desktop */}
      {!isMobile && (
        <Link to="/" id="home-lnk">
          <img className="home-icon" src={homeIcon} alt="Home" />
        </Link>
      )}
      {sidebarItems.map(({ id, icon, label }) => (
        <div
          key={id}
          className={`sidebar-icon-wrapper ${
            mainTab === id ? "active" : ""
          } ${label}`}
          onClick={() => setMainTab(id)}
        >
          <img className="sidebar-icon" src={icon} alt={label} />
          <div className="icon-label">{label}</div>
        </div>
      ))}
    </div>
  );
};

export default Sidebar;
